import React from 'react';
import './DesktopTable.css';
import { DesktopTableHeader } from '../DesktopTableHeader';
import { DesktopTableRow } from '../DesktopTableRow';
import { StringUtilService } from '../../../../../shared/src/services/util/string-util.service';

export const DesktopTable = ({
    tableRows,
    loyaltyLevels,
}) => {
    const levelsNum = loyaltyLevels.length;
    const columnsNum = levelsNum + 1;
    const rowsNum = tableRows.length;
    const lastRowIndex = rowsNum - 1;
    const tableStyles = {
        gridTemplateColumns: `repeat(${columnsNum}, 1fr)`,
    };

    return <div
        className="loyalty-levels-table-desktop"
        style={tableStyles}
    >
        <DesktopTableHeader loyaltyLevels={loyaltyLevels} />
        {tableRows.map((rowData, rowIndex) => <DesktopTableRow
            key={StringUtilService.stringToKebabCase(rowData.title)}
            rowData={rowData}
            levelsNum={levelsNum}
            isLastRow={lastRowIndex === rowIndex}
        />)}
    </div>;
};
